import { Controller } from "@hotwired/stimulus"

// Loading state for forms submitted without Turbo (data-turbo="false").
// The admin sign-in forms skip Turbo so the browser sees a real form navigation:
// password managers only reliably offer to save credentials on one.
export default class extends Controller<HTMLFormElement> {
  static targets = ["submit"]
  static values = { submitsWith: String }

  declare readonly submitTarget: HTMLButtonElement
  declare readonly submitsWithValue: string

  private label = ""

  connect() {
    this.label = this.submitTarget.textContent ?? ""
    window.addEventListener("pageshow", this.reset)
  }

  disconnect() {
    window.removeEventListener("pageshow", this.reset)
  }

  busy() {
    this.submitTarget.disabled = true
    this.submitTarget.setAttribute("aria-busy", "true")
    if (this.submitsWithValue) this.submitTarget.textContent = this.submitsWithValue
  }

  // Coming back through the history cache would otherwise show a stuck button
  private reset = () => {
    this.submitTarget.disabled = false
    this.submitTarget.removeAttribute("aria-busy")
    this.submitTarget.textContent = this.label
  }
}
